import { Dialog } from '../dialog';
import DrawerInternal from './drawer-internal';
import Header from './header';
const DrawerNamespace = Object.assign(DrawerInternal, {
    Body: Dialog.Body,
    Button: Dialog.Button,
    CloseButton: Dialog.CloseButton,
    Footer: Dialog.Footer,
    Header,
});
export default DrawerNamespace;
